import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../videoMeeting.constants";
import { fetchUserMeetings } from "../utils/fetchUserMeetings";
import type { Meeting } from "@core/features/meeting";

export type UseFetchUserMeetingsArgs = {
  user: { id: number } | null;
  isEnabled?: boolean;
};

export function useFetchUserMeetings({
  user,
  isEnabled = true,
}: UseFetchUserMeetingsArgs) {
  return useQuery<Meeting[], Error>({
    queryKey: [QUERY_KEYS.USER_MEETINGS, user?.id],
    queryFn: fetchUserMeetings,
    enabled: !!user && isEnabled,
  });
}
